import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export const menuItems = [
  {
    linkTo: '/',
    linkKey: 'menu_panel',
    icon: 'houseDoor',
  },
  {
    linkTo: '/calendar',
    linkKey: 'menu_calendar',
    icon: 'calendarDate2',
    permission: 207,
    requiredModule: MODULE_KEY_MAP.CALENDAR,
  },
  {
    linkTo: '/agenda',
    linkKey: 'menu_agenda',
    icon: 'list',
    permission: 230,
    requiredModule: MODULE_KEY_MAP.AGENDA,
  },
   {
     linkKey: 'menu_contracts-generator',
     icon: 'filePlus',
     children: [
       {
         linkTo: '/generador-contratos/generador',
         linkKey: 'menu_generator',
       },
       {
         linkTo: '/generador-contratos/contratos',
         linkKey: 'menu_contracts',
       },
     ],
   },
  {
    linkTo: '/estado-diario',
    linkKey: 'menu_dailyState',
    icon: 'calendar1',
    permission: 35,
    requiredModule: MODULE_KEY_MAP.DAILY_STATE,
  },
  {
    linkTo: '/tareas',
    linkKey: 'menu_tasks',
    icon: 'squareCheck',
    permission: 39,
    requiredModule: MODULE_KEY_MAP.TASKS,
  },
  {
    linkTo: '/causas',
    linkKey: 'menu_cases',
    icon: 'briefcase',
    permission: 40,
    requiredModule: MODULE_KEY_MAP.CASES,
  },
  {
    linkKey: 'menu_crm',
    icon: 'users',
    anyPermission: [62, 110],
    children: [
      {
        linkTo: '/crm/clientes',
        linkKey: 'menu_clients',
        permission: 62,
        requiredModule: MODULE_KEY_MAP.CRM,
      },
      {
        linkTo: '/crm/monitoreo-rut',
        linkKey: 'menu_monitorRut',
        permission: 110,
        requiredModule: MODULE_KEY_MAP.CRM,
      },
      // { linkTo: '/crm/cobranza', linkKey: 'menu_collection' },
    ],
  },
  {
    linkKey: 'menu_smartDocs',
    icon: 'fileText',
    anyPermission: [116, 123],
    requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
    children: [
      {
        linkTo: '/smart-docs/gestion-documentos',
        linkKey: 'menu_docManagement',
        permission: 116,
        requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
      },
      {
        linkTo: '/smart-docs/registro-documentos',
        linkKey: 'menu_docRegistry',
        permission: 123,
        requiredModule: MODULE_KEY_MAP.SMART_DOCUMENTS,
      },
    ],
  },
  {
    linkKey: 'menu_messaging',
    icon: 'send',
    anyPermission: [128, 130, 136, 141],
    children: [
      {
        linkTo: '/mensajeria/crear-mensajes',
        linkKey: 'menu_createMessages',
        permission: 130,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
      {
        linkTo: '/mensajeria/campanas',
        linkKey: 'menu_campaigns',
        permission: 136,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
      {
        linkTo: '/mensajeria/tareas-notificaciones',
        linkKey: 'menu_tasksNotifications',
        permission: 141,
        requiredModule: MODULE_KEY_MAP.MESSAGING,
      },
    ],
  },
  {
    linkKey: 'menu_automation',
    icon: 'workflow',
    children: [
      {
        linkTo: '/automatizaciones/configurar-workflow-tareas',
        linkKey: 'menu_taskWorkflow',
      },
      {
        linkTo: '/automatizaciones/solicitudes-aprobacion',
        linkKey: 'menu_approvalRequest',
      },
    ],
  },
  {
    linkKey: 'menu_reports',
    icon: 'fileBarGraph',
    anyPermission: [145, 147, 150, 153, 225],
    requiredModule: MODULE_KEY_MAP.REPORTS,
    ruleKey: 'menu_reports',
    children: [
      {
        linkTo: '/informes/scoring-abogados',
        linkKey: 'menu_lawyerScoring',
        permission: 147,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/uso-plantillas',
        linkKey: 'menu_docUsage',
        permission: 150,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/deteccion-monitoreo',
        linkKey: 'menu_detectionMonitoring',
        permission: 153,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
      {
        linkTo: '/informes/creador-informes',
        linkKey: 'menu_reportCreator',
        permission: 225,
        requiredModule: MODULE_KEY_MAP.REPORTS,
        ruleKey: 'menu_reports',
      },
    ],
  },
  {
    linkKey: 'menu_ai',
    icon: 'sparkles',
    permission: [158, 294],
    ruleKey: 'menu_ai',
    children: [
      {
        linkTo: '/ia/protocolos',
        linkKey: 'menu_protocols',
        permission: 158,
        requiredModule: MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE,
        ruleKey: 'menu_ai',
      },
      {
        linkTo: '/ia/no-clientes',
        linkKey: 'menu_noClients',
        permission: 294,
        requiredModule: MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE,
        ruleKey: 'menu_ai',
      },
    ],
  },
  {
    linkKey: 'menu_marketing',
    icon: 'fileBarGraph',
    anyPermission: [228, 229],
    children: [
      {
        linkTo: '/marketing/analisis-marketing',
        linkKey: 'menu_marketingAnalysis',
        permission: 228,
        requiredModule: MODULE_KEY_MAP.MARKETING,
        ruleKey: 'menu_marketing',
      },
      {
        linkTo: '/marketing/transcripciones-sac',
        linkKey: 'menu_marketingSacTranscripts',
        permission: 229,
        requiredModule: MODULE_KEY_MAP.MARKETING,
        ruleKey: 'menu_marketing',
      },
    ],
  },
];
